import {i18n} from '@mira/i18n';
import {addDays, differenceInMonths, differenceInYears} from 'date-fns';

import {isNil} from 'ramda';

import {ROW_TYPE_THRESHOLDS} from '../constants/categoryMapping';

const KM_PER_DAY = 50;
const KM_ROUNDING_FACTOR = 1000;
const RUL_NOW_THRESHOLD_DAYS = 7;
const RUL_SOON_THRESHOLD_DAYS = 30;

export function getRulLabel(
  will_need: boolean,
  rul_days: number | null,
  confidence: number
): string {
  if (!will_need) {
    return confidence >= ROW_TYPE_THRESHOLDS.DAMAGE
      ? i18n.t('rul.likelyFine')
      : i18n.t('rul.worthChecking');
  }

  if (isNil(rul_days)) {
    return i18n.t('rul.worthChecking');
  }

  if (rul_days <= RUL_NOW_THRESHOLD_DAYS) {
    return i18n.t('rul.now');
  }

  if (rul_days <= RUL_SOON_THRESHOLD_DAYS) {
    return i18n.t('rul.soonWithDays', {count: Math.round(rul_days)});
  }

  const totalKm = rul_days * KM_PER_DAY;
  const roundedKm = Math.round(totalKm / KM_ROUNDING_FACTOR) * KM_ROUNDING_FACTOR;
  const formattedKm = roundedKm.toLocaleString(i18n.language);

  const today = new Date();
  const futureDate = addDays(today, rul_days);
  const monthsDiff = differenceInMonths(futureDate, today);
  const yearsDiff = differenceInYears(futureDate, today);

  if (yearsDiff < 1) {
    return i18n.t('rul.monthsWithKm', {count: monthsDiff, distance: formattedKm});
  }

  return i18n.t('rul.yearsWithKm', {count: yearsDiff, distance: formattedKm});
}
